import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import TableActionButton from '../../../../../components/CustomTableWithPagination/TableActionButton';

const renderStatusIcon = (value) => {
  return value ? <CheckCircleIcon sx={{ color: 'success.main' }} /> : <CancelIcon sx={{ color: 'error.main' }} />;
};

// Status icon + Sync button living in the same cell, so each entity has a
// single self-explanatory column: the icon shows the current sync state and
// the button triggers/repeats the sync.
const renderSyncCell = ({ synced, actionKey, rowId }) => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
    {synced ? (
      <CheckCircleIcon sx={{ color: 'success.main' }} titleAccess="Synced" />
    ) : (
      <CancelIcon sx={{ color: 'error.main' }} titleAccess="Not synced" />
    )}
    <TableActionButton
      actionKey={actionKey}
      rowId={rowId}
      icon="mdi:sync"
      label={synced ? 'Re-sync' : 'Sync'}
      title={synced ? 'Already synced — click to re-sync' : 'Sync now'}
      buttonProps={{ style: { minWidth: 104 } }}
    />
  </div>
);

export const LensSyncTableHeader = () => [
  { field: 'slNo', headerName: 'Sl_No', width: 120, toolTipGetter: true },
  {
    field: 'admn_no',
    headerName: 'Admission No',
    width: 160,
    toolTipGetter: true,
  },

  {
    field: 'student_name',
    headerName: 'Student Name',
    width: 220,
    toolTipGetter: true,
  },
  {
    field: 'course_name',
    headerName: 'Course Name',
    width: 220,
    toolTipGetter: true,
  },
  {
    field: 'subject_name',
    headerName: 'Subject Name',
    width: 200,
    toolTipGetter: true,
  },
  {
    field: 'name',
    headerName: 'CRM name',
    width: 200,
    toolTipGetter: true,
  },
  {
    field: 'full_name',
    headerName: 'Tutor Name',
    width: 200,
    toolTipGetter: true,
  },
  {
    field: 'scheduled_sessions_count',
    headerName: 'Scheduled Sessions',
    width: 220,
    renderCell: (params) =>
      renderSyncCell({
        synced: params.row.scheduled_sessions_count,
        actionKey: 'sessionSync',
        rowId: params.row.slNo,
      }),
  },

  // ---- Combined status + action cells (Student → Tutor → Course → All) ----
  {
    field: 'studentSync',
    headerName: 'Student Sync',
    width: 200,
    renderCell: (params) =>
      renderSyncCell({
        synced: params.row.wise_student_id,
        actionKey: 'studentSync',
        rowId: params.row.slNo,
      }),
  },
  {
    field: 'tutorSync',
    headerName: 'Tutor Sync',
    width: 200,
    renderCell: (params) =>
      renderSyncCell({
        synced: params.row.wise_teacher_id,
        actionKey: 'tutorSync',
        rowId: params.row.slNo,
      }),
  },
  {
    field: 'courseSync',
    headerName: 'Course Sync',
    width: 200,
    renderCell: (params) =>
      renderSyncCell({
        synced: params.row.wise_course_classroom_id,
        actionKey: 'courseSync',
        rowId: params.row.slNo,
      }),
  },
  {
    field: 'allSync',
    headerName: 'Sync All',
    type: 'action',
    actionKey: 'allSync',
    width: 160,
    buttonName: 'Sync All',
  },
];
